import VendorShowWinState from '../../../vendor_core/src/states/VendorShowWinState';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import PointerEvents from '../../../vendor_core/core/src/const/PointerEvents';
import Layer from '../../../vendor_core/core/src/utils/Layer';
import StateMachine from '../../../vendor_core/core/src/states/StateMachine';
import Configs from '../../../vendor_core/src/vendorConfigs/Configs';
import { ConfigurationTypes } from '../../../vendor_core/core/src/const/ConfigurationTypes';
import IFantasmaConfig from '../../../vendor_core/src/server/data/IFantasmaConfig';
import ConfigManager from '../../../vendor_core/core/src/managers/ConfigManager';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import BetModel from '../../../vendor_core/core/src/model/BetModel';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';
import VendorWinlinesView from '../../../vendor_core/src/view/VendorWinlinesView';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import { Tween } from '../../../vendor_core/core/src/Tween';
import BackgroundHelper from '../view/background/BackgroundHelper';
import App from '../../../vendor_core/core/src/App';
import { UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import UIController from '../../../vendor_core/core/src/ui/UIController';

export default class VOEShowWinState extends VendorShowWinState {

  protected backgroundLayer: Layer;
  
  public enter(): void {
    super.enter();

    this.backgroundLayer = ViewManager.getLayer(DefaultLayers.PaylineCelebration);
    this.backgroundLayer.interactive = true;
    this.backgroundLayer.on(PointerEvents.DOWN, this.skipWin, this);
  }

  displayWin() {
    super.displayWin();

    if (SpinModel.hasBigWin()) {
      UIController.setState(UIStates.SPIN_END);
    }
  }

  private playReelsLight(delay) {
    // only in BigWin
    if (SpinModel.hasBigWin()) {
      let lightReelDelay = delay;
      if (delay > 0.5) {
        // we have to start reels lightin anim(is background anim) 0.5 sec befor to enter in BigWin
        lightReelDelay = delay - 0.5;
      }

      if (SpinModel.featureMode != -1) {
        if (SpinModel.featureMode == 1) {
            BackgroundHelper.backgrounBN1Win();
        } else {
            BackgroundHelper.backgrounBN2Win();
        }
      }
    }
  }

  protected attachOnCompleteEvent() {
    this.reelGroup.winlinesView.once(
       GameEvents.BANNER_ANIM_COMPLETE,
       () => {
           // This game has big win pre sound, which must be heard, then we enter big win.
           const delay = SpinModel.hasBigWin() ? 1.25 : this.getUnlockTime();
           Tween.delayedCall(delay, () => {
               this.exit();
           });

           this.playReelsLight(delay);
       },
       this
   );
}

  private skipWin() {
    if (this.canExit()) {
      this.skip();
    }
  }

  skip() {
    const elapsedSeconds = (new Date().getTime() - (<any>StateMachine.currentState).timer) / 1000;
        
    if (elapsedSeconds <= ConfigManager.getConfig<IFantasmaConfig>(ConfigurationTypes.GAME).minWinAnimTime) {
      return;
    }
    
    App.dispatcher.emit(GameEvents.WIN_INTERCEPTED);
    const scene = this.backgroundLayer.setScene("totalWin");
    let winSpine = scene.spineAnimations.get("totalWins");
    const config = Configs.game.clientConfig;
    const disableLowWinCelebration = config.disableLowWinCelebration && SpinModel.getCurrentWin() <= BetModel.totalBet;
    const winLineView = ReelGroup.instance.winlinesView as VendorWinlinesView;
    if (!disableLowWinCelebration) {
        winSpine.stop(false);
        winLineView.winValueBannerBangUp.clearBangup();
    }
  }

  public exit(): void {
    this.backgroundLayer.interactive = false;
    this.backgroundLayer.off(PointerEvents.DOWN);
    super.exit();
  }
}